import { loadStripe } from '@stripe/stripe-js';
import { auth, db } from '../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

// Replace with your Stripe publishable key
let stripePromise = null;

export const initStripe = (publishableKey) => {
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
};

export const PRODUCT_IDS = {
  BASIC: 'price_1RHCNPFFx8XNFT50C6uXWb3W',      // Premium plan (ILS)
  PROFESSIONAL: 'price_1RtJxJFFx8XNFT50cEFqCzlS', // Enterprise plan (ILS)
  BASIC_USD: 'price_1RW06HFFx8XNFT50cO3aWJJ5',    // Premium plan (USD)
  PROFESSIONAL_USD: 'price_1RW03dFFx8XNFT50BMVLecGY' // Enterprise plan (USD)
};

export async function initiateSubscription(priceId) {
  console.log('Initiating subscription with price ID:', priceId);
  if (!stripePromise) {
    console.error('Stripe not initialized');
    throw new Error('Stripe has not been initialized. Call initStripe first.');
  }
  try {
    const functions = getFunctions();
    const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
    // Only send priceId
    const { data } = await createCheckoutSession({ priceId });
    const { sessionId } = data;
    if (!sessionId) {
      throw new Error('No session ID returned from createCheckoutSession');
    }
    const stripe = await stripePromise;
    console.log('Stripe loaded, redirecting to checkout...');
    const { error } = await stripe.redirectToCheckout({ sessionId });
    if (error) {
      console.error('Stripe error:', error);
      throw error;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

// Function to handle successful subscription
export const handleSuccessfulSubscription = async (sessionId) => {
  try {
    const functions = getFunctions();
    const verifySubscription = httpsCallable(functions, 'verifySubscription');
    
    const { data: subscriptionData } = await verifySubscription({ sessionId });
    await storeStripeCustomerData(subscriptionData);
    return subscriptionData;
  } catch (error) {
    console.error('Error handling subscription:', error);
    throw error;
  }
};

// Function to store Stripe customer data in Firestore
const storeStripeCustomerData = async (subscriptionData) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('No authenticated user found');
    }

    const userRef = doc(db, 'users', user.uid);
    await setDoc(userRef, {
      subscription: subscriptionData,
      updatedAt: serverTimestamp()
    }, { merge: true });

    // Refresh the user's ID token to get the new custom claims
    await user.getIdToken(true);
  } catch (error) {
    console.error('Error storing Stripe data:', error);
    throw error;
  }
};

// Function to create customer portal session for subscription management
export const createCustomerPortalSession = async () => {
  try {
    const functions = getFunctions();
    const createPortalSession = httpsCallable(functions, 'createCustomerPortalSession');
    
    const { data } = await createPortalSession();
    
    if (data.url) {
      // Navigate to Stripe customer portal in the current window
      window.location.href = data.url;
    } else {
      throw new Error('No portal URL returned');
    }
  } catch (error) {
    console.error('Error creating customer portal session:', error);
    throw error;
  }
}; 